module.exports = "pegasus/assets/background-patterns/fall-default-theme.jpg";